<template>
  <div class="">
    <!-- 导入对话框 -->
    <el-dialog
      append-to-body
      :close-on-click-modal="false"
      :title="importData.title"
      :visible="params.open"
      :before-close="dialogBeforeClose"
      width="600px"
    >
      <el-upload
        ref="importData"
        :limit="1"
        accept=".xlsx, .xls"
        :headers="headers"
        :action="importData.url"
        :disabled="isUploading"
        :file-list="fileList"
        :on-success="handleUploadSuccess"
        :before-upload="handleBeforeUpload"
        :on-error="handleUploadError"
        :auto-upload="false"
        :on-exceed="importExcelLimitCallbck"
        drag
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将文件拖到此处，或
          <em>点击上传</em>
        </div>
        <div class="el-upload__tip" slot="tip">
          <!-- <el-checkbox
            v-model="importData.updateSupport"
          />是否更新已经存在的用户数据 -->
          <el-link
            type="success"
            style="font-size: 14px; margin-left: 5px"
            @click="importTemplate(importData.templateFile)"
            >下载模板</el-link
          >
        </div>
        <div class="el-upload__tip" style="color: red" slot="tip">
          提示：仅允许导入“xls”或“xlsx”格式文件！
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="importDataSubmit">确 定</el-button>
        <el-button @click="cancelDialog">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getToken } from "@/utils/auth";

export default {
  components: {},
  data() {
    return {
      params: this.importData,
      // 是否禁用上传
      isUploading: false,
      // 设置上传的请求头部
      headers: { Authorization: "Bearer " + getToken() },
      // 导入文件列表
      fileList: [],
    };
  },
  props: {
    importData: {
      type: Object,
      default: undefined,
    },
  },
  created() {},
  methods: {
    /** 下载模板操作 */
    importTemplate(file) {
      var name = file.fileName;
      var url = window.location.origin + file.filePath;
      var suffix = url.substring(url.lastIndexOf("."), url.length);
      const a = document.createElement("a");
      console.log("url", url);
      a.setAttribute("download", name + suffix);
      // a.setAttribute("target", "_blank");
      a.setAttribute("href", url);
      a.click();
      a.remove();
    },
    // 导入数据
    importDataSubmit() {
      this.$refs.importData.submit();
    },
    handleUploadSuccess(response) {
      if (response.code == 200) {
        this.$message.success(`导入成功`);
      } else {
        this.$message.error(response.msg);
      }
      this.$refs.importData.clearFiles();
      this.$emit("refresh");
      this.loading.close();
      this.params.open = false;
    },
    handleBeforeUpload() {
      this.loading = this.$loading({
        lock: true,
        text: "上传中，请耐心等待...",
        background: "rgba(0, 0, 0, 0.6)",
      });
    },
    handleUploadError() {
      this.$message({
        type: "error",
        message: "上传失败",
      });
      this.loading.close();
    },
    // 文件超出个数限制时的钩子函数
    importExcelLimitCallbck() {
      this.$message.warning(`当前限制最多导入 1 个文件`);
    },
    // 关闭导入对话框前事件
    dialogBeforeClose() {
      this.fileList = [];
      this.params.open = false;
    },
    // 关闭导入对话框
    cancelDialog() {
      this.fileList = [];
      this.params.open = false;
    },
  }, // method end
  watch: {},
};
</script>

<style rel="stylesheet/scss" lang="scss">
.dialog-title {
  display: flex;
  justify-content: space-between;
  margin-right: 24px;
}
.el-upload-dragger {
  width: 560px;
  height: 200px;
}
</style>
